

exports.__esModule = true;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _index = require('squid/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/app/index');

var _index4 = require('xo-models/src/user/index');

var _util = require('pages/xo-login/util');

var _uiRouter = require('uiRouter');

var _config = require('squid/dist/core/config');

var _squid = require('squid');

require('xo-page-components/src/value-props/directive');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

var _factory = require('pages/xo-login/tokenized-wallet-loader/factory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoEConsentPageDirective', {
    tag: 'xo-econsent-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token),
                eConsent: _index4.$EConsentModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                tokenizedWalletEligibility: _index3.$TokenizedWalletEligibilityModel.instance(this.props.token),
                tokenizedWalletPin: _index3.$TokenizedWalletPinModel.instance(this.props.token),
                tokenizedWalletInfoModel: _index3.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedWalletMsbOffer: _index3.$TokenizedWalletMsbOfferModel.instance(this.props.token)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
        }
    },
    actions: {
        submit: function submit() {
            var _this = this;

            var self = this;
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            var hardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

            self.handleSymphonyContingency = function (name, err) {
                // Check if negative case has been previously handled.
                if (!self.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = hardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);
                throw err;
            };

            self.handleSymphonyNoValidTopupFiContingency = function (name, err) {
                // Check if negative case has been previously handled.
                if (!self.dependencyEligibility) {
                    return;
                }

                if (self.models.checkoutCart.isWalletTokenization()) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = hardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    self.models.checkoutSession.contingency = name;
                    return _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    self.handleSymphonyContingency(name, err);
                }
            };

            // We use this flag to tell if negative case has been previously handled.
            self.dependencyEligibility = true;

            // We use this flag to decide if we should to review page.
            // Set this to false if the next page is no review page.
            self.proceedToReview = true;

            var isPayPalCredit = self.models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            var eConsentBatch = [this.models.eConsent.save({
                batch: {
                    name: 'econsent',
                    id: 'accept'
                }
            }), this.models.checkoutSession.action('create', {
                data: {
                    baToken: this.models.checkoutCart.get('billing.ba_token'),
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    clear_installments: true
                },
                success: function success(result) {
                    // Check if negative case has been previously handled.
                    if (!self.dependencyEligibility) {
                        return;
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'CREATE_XO_SESSION',
                        to: 'process_create_xo_session'
                    });

                    // consider negative balance first
                    if (self.models.checkoutSession.negBals) {
                        self.proceedToReview = false;
                        return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                    }

                    // Handle routing to cape for second button
                    if (isPayPalCredit) {
                        self.proceedToReview = false;
                        return _util.$capeRedirectUtil.handleCapeRouting(result, self.models.checkoutCart, self.props.token);
                    }

                    // Check for tokenized wallet
                    if (self.models.checkoutCart.isWalletTokenization()) {
                        return _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                    }
                },

                contingencies: {
                    NEED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
                    DEFAULT: self.handleSymphonyContingency
                },
                batch: {
                    name: 'econsent',
                    id: 'createCheckout',
                    dependencies: self.models.checkoutCart.isWalletTokenization() ? ['accept', 'tokenizedWalletLightEligibility', 'tokenizedWalletPin'] : ['accept']
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete _this.models.checkoutSession.selectedInstallmentData;
            })];

            if (self.models.checkoutCart.isWalletTokenization()) {
                // Wallet tokenization always goes tokenization info page unless there is an error
                // which is tracked by a separate flag.
                self.proceedToReview = false;

                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _self$models$tokenize = self.models.tokenizedWalletInfoModel,
                    wallet_id = _self$models$tokenize.wallet_id,
                    external_device_id = _self$models$tokenize.external_device_id,
                    tr_client_id = _self$models$tokenize.tr_client_id,
                    product_name = _self$models$tokenize.product_name;

                var subject = self.models.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_config.$meta.query && _config.$meta.query.wallet_id) {
                    params.wallet_id = _config.$meta.query.wallet_id;
                }
                if (_config.$meta.query && _config.$meta.query.jwt) {
                    params.jwt = _config.$meta.query.jwt;
                }

                eConsentBatch.push(this.models.tokenizedWalletEligibility.retrieve({
                    params: params,

                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            fptiData.int_error_code = result.reason;
                            fptiData.error_source = 'paymenttokenserv';
                            fptiData.error_type = 'hard_decline';
                            _logger.$logger.info('checkout_fpti', fptiData);

                            self.dependencyEligibility = false;
                            var code = result.reason === 'WALLET_ID_ALREADY_PROVISIONED' ? 'ANDROID_PAY_ALREADY_PROVISIONED' : 'ANDROID_PAY_ELIGIBILITY_ERROR';

                            code = window.btoa(code);
                            return _uiRouter.$state.go('checkout.genericError', {
                                code: code
                            });
                        }
                    },


                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletLightEligibility',
                        dependencies: ['accept']
                    }
                }));

                eConsentBatch.push(this.models.tokenizedWalletPin.retrieve({
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', { pinOrigin: result.pinOrigin, pinId: result.pinId });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set');
                        }
                    },


                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                        }
                    },

                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletPin',
                        dependencies: ['accept']
                    }
                }));

                eConsentBatch.push(this.models.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: this.models.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletMsbOffer',
                        dependencies: ['accept']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                }));
            }

            return _angular.$q.all(eConsentBatch).then(function () {
                if (self.proceedToReview) {
                    return _this.props.success();
                }
            });
        }
    }
});


_angular.$q;

_logger.$logger;

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index3.$TokenizedWalletEligibilityModel;

_index3.$TokenizedWalletPinModel;

_index3.$TokenizedWalletInfoModel;

_index3.$TokenizedWalletMsbOfferModel;

_index4.$EConsentModel;

_util.$capeRedirectUtil;

_uiRouter.$state;

_config.$meta;

_squid.$Class;

_factory.$TokenizedWalledLoaderFactory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-eConsent/directive.js
// module id = ./pages/xo-eConsent/directive.js
// module chunks = 0